import * as React from 'react';
import PropTypes from "prop-types";

import { Row, Col, Input, Button } from 'reactstrap';

export class AdmisionesConsulta extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            anios: props.anioOptions, terminos: props.terminoOptions,
            anio: props.aniosValue, termino: props.terminosValue, apellidos: "", nombres: ""
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleDocenteChange = this.handleDocenteChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange = event => {
        this.setState({ apellidos: "", nombres: "" });
        this.props.onInputChange(event);
    }

    handleDocenteChange = event => {
        let name = event.target.name;
        let value = event.target.value;
        if (name == "apellidos") {
            this.setState({ apellidos: value });
        }
        else if (name == "nombres") {
            this.setState({ nombres: value });
        }
    }

    handleSubmit = event => {
        event.preventDefault();
        this.props.handleDocenteSubmit(this.state.apellidos, this.state.nombres);
    }

    render() {
        return (
            <div>
                <form name="consulta" onSubmit={this.handleSubmit}>
                    <Row className="form-group">
                        {this.props.anioOptions && this.props.anioOptions.length > 0 ?
                            <>
                                <Col md={1}>
                                    <label className=" control-label" htmlFor="anio">Año:</label>
                                </Col>
                                <Col md={3}>
                                    <Input
                                        type="select"
                                        value={this.props.anioValue}
                                        placeholder="Año"
                                        name="anio"
                                        id="anio"
                                        onChange={this.handleChange}>
                                        {this.props.anioOptions.map((a, idx) => <option key={idx} value={a}>{a}</option>)}
                                    </Input>
                                </Col>
                            </>
                            : ''}
                        {this.props.terminoOptions && this.props.terminoOptions.length > 0 ?
                            <>
                                <Col md={1}>
                                    <label className=" control-label" htmlFor="termino">Términos:</label>
                                </Col>
                                <Col md={3} className="w-100">
                                    <Input
                                        type="select"
                                        name="termino"
                                        value={this.props.terminoValue}
                                        onChange={this.handleChange}>
                                        {this.props.terminoOptions.map((t, idx) => <option key={idx} value={t}> {t}</option>)}
                                    </Input>
                                </Col>
                            </>
                            : ''}
                    </Row>
                    <Row key={0} className="form-group">
                        <Col md={1}>
                            <label className=" control-label" htmlFor="unidad">Apellidos:</label>
                        </Col>
                        <Col md={3} className="w-100">
                            <Input
                                type="text"
                                placeholder="Apellidos"
                                name="apellidos"
                                id="apellidos"
                                value={this.state.apellidos}
                                onChange={this.handleDocenteChange}
                                maxLength={30}
                            >
                            </Input>
                        </Col>
                        <Col md={1}>
                            <label className=" control-label" htmlFor="programa">Nombres:</label>
                        </Col>
                        <Col md={3} className="w-100">
                            <Input
                                type="text"
                                placeholder="Nombres"
                                name="nombres"
                                id="nombres"
                                value={this.state.nombres}
                                onChange={this.handleDocenteChange}
                                maxLength={30}
                            >
                            </Input>
                        </Col>
                        <Col md={3}><Button type="submit">Buscar docente</Button></Col>
                    </Row>
                </form>
            </div>
        );
    }
}

AdmisionesConsulta.propTypes = {
    aniosOptions: PropTypes.array,
    aniosValue: PropTypes.any,
    terminosOption: PropTypes.any,
    terminosValue: PropTypes.any,
    onInputChange: PropTypes.func,
};

